import React from 'react';
import { images } from '../data/business';
interface LogoProps {
  tone?: 'dark' | 'light';
  className?: string;
}
export function Logo({
  tone = 'dark',
  className = 'h-11 lg:h-14'
}: LogoProps) {
  return <img src={images.logo} alt="Innova Pools & Systems" className={`block w-auto ${className} ${tone === 'light' ? 'brightness-0 invert' : ''}`} draggable={false} data-id="element-180" data-mp="3qamdn7lw9x67" />;
}